import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faPlus, faSave, faSearch, faFilePdf, faArrowLeft, faBroom, faAdd } from '@fortawesome/free-solid-svg-icons';
import './Approval.css'
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import { useNavigate, useParams } from 'react-router-dom';
import GoCast from '../../Images/GoCast.png'
import { act } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
////////////////////////////////////////

const ApprovalForm = () => {

    // Loading GIF
    const [isLoading, setIsLoading] = useState(false);

    // Navigation To Another Page
    const navigate = useNavigate();

    // Returns Dynamic Parameter from ApprovalGrid :approvalID
    const { approvalID } = useParams();

    // Option Panel visibility
    const [panel1Visible, setPanel1Visible] = useState(true);

    // Advanced Panel visibility
    const [panel2Visible, setPanel2Visible] = useState(true);

    // Date Picker

    const [selectedDate, setSelectedDate] = useState(null);

    const handleChange = (date) => setSelectedDate(date);

    // Toggle Option Panel visibility
    const togglePanel1Visibility = () => {
        setPanel1Visible(!panel1Visible);
    }
    // Toggle Advanced Panel visibility
    const togglePanel2Visibility = () => {
        setPanel2Visible(!panel2Visible);
    }

    //        API CODE FOR Form
    const [apiData, setApiData] = useState({});
    //        API CODE FOR Grid
    const [tableapiData, settableApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5); // Adjust this number as needed
    // Add new
    const [showEmptyRow, setShowEmptyRow] = useState(false);
    const [showNewEmptyRow, setShowNewEmptyRow] = useState(false);
    //update fields
    const [codeTypeID, setcodeTypeID] = useState('');
    const [description, setDescription] = useState('');
    const [fullDescription, setFullDescription] = useState('');
    const [createDate, setCreateDate] = useState('');
    const [autoSequence, setAutoSequence] = useState(false);
    const [sequence, setSequence] = useState('');
    //update fields 2
    const [codeID, setcodeID] = useState('');
    const [active, setActive] = useState(false);
    const [childDescription, setChildDescription] = useState('');
    const [childCreateDate, setChildCreateDate] = useState('');
    const [finalApproval, setFinalApproval] = useState(false);
    //       Fetch 
    const [modifiedData, setModifiedData] = useState({});


    const fetchData = async () => {
        setIsLoading(true); // Load GIF
        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UserCodes(PRECAST,${approvalID})`; // Adjust the URL as needed
        const apiUDCodes = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UDCodes?$filter= CodeTypeID eq '${approvalID}'`;
        try {
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setApiData(data); // Set the state with the response object directly
            setIsLoading(false); // Loading GIF
            ////////////////////////// Table Grid Data /////////////////////////////////
            const response2 = await fetch(apiUDCodes, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });
            const data2 = await response2.json();

            if (typeof data2 === 'object' && data2 !== null && Array.isArray(data2.value)) {
                settableApiData(data2.value);
                setIsLoading(false); // Loading GIF
            } else {
                console.error('API response does not contain the expected array in the "value" property:', data2);
            }

        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []); // Fetch data on component mount

    ///////////////// Navigation ///////////////////////

    const GoBack = () => {
        navigate(-1); // Navigates back to the previous page
    };

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = tableapiData.slice(startIndex, endIndex);

        return (
            <>{currentItems.map((item, index) => (
                <tr key={index}>
                    <td>{item.CodeID}</td>
                    <td>
                        <input
                            type="checkbox"
                            checked={item.IsActive ? 'true' : ''}
                        />
                    </td>
                    <td>{item.CodeDesc}</td>
                    <td>{new Date(item.CreateDate).toLocaleDateString('en-US')}</td>
                    <td>{item.CreateUser}</td>
                    <td>
                        <input
                            type="checkbox"
                            checked={item.FinalApproval_c ? 'true' : ''}
                        />
                    </td>
                </tr>
            ))}
                {/* Add input fields for the empty row */}
                {showNewEmptyRow && (
                    <tr>
                        <td><input type="text" placeholder="Code ID" value={codeID} onChange={(e) => setcodeID(e.target.value)} /></td>
                        <td><input type="checkbox" checked={active} onChange={(e) => setActive(e.target.checked)} /></td>
                        <td><input type="text" placeholder="Description" value={childDescription} onChange={(e) => setChildDescription(e.target.value)} /></td>
                        <td><input type="text" placeholder="Create Date" value={childCreateDate} onChange={(e) => setChildCreateDate(e.target.value)} /></td>
                        <td><input type="text" placeholder="Created By" /></td>
                        <td><input type="checkbox" checked={finalApproval} onChange={(e) => setFinalApproval(e.target.checked)} /></td>
                    </tr>
                )}

            </>
        )
    };


    //      Update 
    const saveData = async () => {
        setIsLoading(true); // Loading GIF
        const username = 'manager';
        const password = 'manager';

        if (showEmptyRow) {
            const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UserCodes`;
            const newRow = {
                "Company": "PRECAST",
                "CodeTypeID": codeTypeID,
                "CodeTypeDesc": description,
                "LongDesc": fullDescription,
                "CreateDate": "2024-05-20T00:00:00",
                "CreateUser": "MANAGER",
                "AutoSequence": autoSequence,
                "SequenceID": sequence
            };
            console.log(newRow)
            try {
                const response = await axios.post(apiUrl, newRow, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                setShowEmptyRow(false)
                console.log('Data saved successfully:', response.data);
                fetchData();
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
                navigate(`/approval/approvalform/${codeTypeID}`, { replace: true });
            } catch (error) {
                console.error('Error:', error.message);
                // Toast Notifcation
                setTimeout(() => {
                    toast.error("Failed To Save");
                }, 10);
            }

        }
        else {
            const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UserCodes(PRECAST,${approvalID})`;
            try {
                const response = await axios.patch(apiUrl, modifiedData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                console.log('Data saved successfully:', response.data);
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
            } catch (error) {
                console.error('Error:', error.message);
                // Toast Notifcation
                setTimeout(() => {
                    setIsLoading(false); // Loading GIF
                    toast.error("Failed To Save");
                }, 10);
            }
        }

    };

    const saveChildData = async () => {
        const username = 'manager';
        const password = 'manager';
        const apiUrl = `https://77.92.189.102/iiprecastverticaldemo/api/v1/Ice.BO.UserCodesSvc/UDCodes?$filter= CodeTypeID eq '${approvalID}'`;
        const newRow = {
            "Company": "PRECAST",
            "CodeTypeID": approvalID,
            "CodeID": codeID,
            "IsActive": active,
            "CodeDesc": childDescription,
            "LongDesc": "EX",
            "CreateDate": "2024-05-20T00:00:00",
            "CreateUser": "MANAGER",
            "codeTypeIDDescCodeTypeDesc": approvalID,
            "FinalApproval_c": finalApproval
        };
        console.log(newRow)
        try {
            const response = await axios.post(apiUrl, newRow, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });
            setShowNewEmptyRow(false)
            fetchData();
            console.log('Data saved successfully:', response.data);
            // Toast Notifcation
            setTimeout(() => {
                toast.success("Data Saved Successfully");
            }, 10);
        } catch (error) {
            console.error('Error:', error.message);
            // Toast Notifcation
            setTimeout(() => {
                toast.error("Failed To Save");
            }, 10);
        }

    };

    const handleInputChange = (e, field) => {
        const newValue = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        setModifiedData(prevState => ({
            ...prevState,
            [field]: newValue
        }));
    };
    const addNew = () => {
        console.log("Add button clicked!");
        // Reset the modifiedData state to clear all fields
        setModifiedData({});
        settableApiData([]);
        // Optionally, if you want to reset the apiData state as well, uncomment the following line
        setApiData({}); // Uncomment this line if you also want to reset the apiData state
        setShowEmptyRow(true)
    };
    const addNewRow = () => {
        console.log("Add button 2 clicked!");

        setShowNewEmptyRow(true);
    };

    return (

        <div className='card panelcard'>
            <ToastContainer />
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className='DetailsForm'>
                <div className="card-header">
                    <button type="button" className="toggle-table-icon" onClick={GoBack}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                    {/* <h2 className='panel-title-report'>Approval Setup</h2> */}
                    <div className='ctrl-btns-approvalform'>
                        <button className="btn" id='preview' onClick={addNew}>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <Tooltip
                            anchorSelect="#preview"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='Save' onClick={saveData}>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#Save"
                            content="Save"
                            place='bottom'
                        />
                        <button className="btn" id='Clear'>
                            {/* <FontAwesomeIcon icon={faBroom} /> */}
                            <svg className='myBroom' width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-width="0.744">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path d="M22.4524 1.92267C22.7452 2.21557 22.7452 2.69044 22.4524 2.98333L16.1393 9.29634C15.9927 9.11579 15.8353 8.94105 15.6673 8.77297C15.4768 8.58252 15.2778 8.40582 15.0715 8.24289L21.3917 1.92267C21.6846 1.62978 22.1595 1.62978 22.4524 1.92267Z" fill="#000"></path>
                                    <path d="M15.0277 9.34728C12.7822 7.10177 9.14153 7.10177 6.89601 9.34728L6.65198 9.59131L14.7837 17.723L15.0277 17.479C17.2733 15.2335 17.2733 11.5928 15.0277 9.34728Z" fill="#000"></path>
                                    <path d="M1.8838 12.9659L5.49664 10.5573L13.8177 18.8784L11.4091 22.4912C11.2845 22.6782 11.0826 22.7994 10.859 22.8215C10.6354 22.8437 10.4137 22.7644 10.2548 22.6055L1.76949 14.1202C1.61061 13.9613 1.53133 13.7396 1.55347 13.516C1.57561 13.2924 1.69684 13.0905 1.8838 12.9659Z" fill="#000"></path>
                                </g>
                            </svg>
                        </button>
                        <Tooltip
                            anchorSelect="#Clear"
                            content="Clear Form"
                            place='bottom'
                        />
                    </div>
                </div>
                {/* Panel 1  */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel1Visibility}>
                            <FontAwesomeIcon icon={panel1Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Approval Setup Types
                        </h5>
                    </div>
                    {panel1Visible && (
                        <div class="table-responsive-md">
                            <div className='ApprovalForm'>
                                <form>
                                    <div class="row row1">
                                        <div class="col-3 leftCol">
                                            <div className="label-input-box-approval">
                                                <input
                                                    type="text"
                                                    id="codeTypeID"
                                                    defaultValue={apiData.CodeTypeID} 
                                                    onChange={(e) => showEmptyRow ? setcodeTypeID(e.target.value) : handleInputChange(e, 'CodeTypeID')}
                                                    placeholder=" "
                                                />
                                                <label htmlFor="codeTypeID">Code Type ID</label>
                                            </div>
                                            <div className="label-input-box-approval">
                                                <input
                                                    type="text"
                                                    id="codeDesc"
                                                    defaultValue={apiData.CodeTypeDesc} 
                                                    onChange={(e) => showEmptyRow ? setDescription(e.target.value) : handleInputChange(e, 'CodeTypeDesc')}
                                                    placeholder=" "
                                                />
                                                <label htmlFor="codeDesc">Description</label>
                                            </div>
                                        </div>
                                        <div class="col-3 midCol">
                                            <div className='chkbox-container checkauto'>
                                                <input class="form-check-input " type="radio" id="Delivery_Trip1" name='Delivery_Trip' defaultChecked={apiData.AutoSequence} onChange={(e) => showEmptyRow ? setAutoSequence(e.target.value) : handleInputChange(e, 'AutoSequence')} />
                                                <label class="form-check-label " for="Delivery_Trip1">Auto Sequence
                                                </label>
                                            </div>
                                            <div className="label-input-box-approval nextsequence">
                                                <input
                                                    type="text"
                                                    id="endDate"
                                                    defaultValue={apiData.SequenceID}
                                                    onChange={(e) => showEmptyRow ? setSequence(e.target.value) : handleInputChange(e, 'SequenceID')} 
                                                    placeholder=" "
                                                />
                                                <label htmlFor="endDate">Next Sequence ID</label>
                                            </div>
                                        </div>
                                        <div class="col-3 rightColForm">
                                            <div className="label-input-box-approval">
                                                <input
                                                    type="text"
                                                    id="endDate"
                                                    defaultValue={apiData.CreateDate}
                                                    onChange={(e) => showEmptyRow ? setCreateDate(e.target.value) : handleInputChange(e, 'CreateDate')}
                                                    placeholder=" "
                                                />
                                                <label htmlFor="endDate">Created</label>
                                            </div>
                                            <div className="label-input-box-approval">
                                                <input
                                                    type="text"
                                                    id="endDate"
                                                    defaultValue={apiData.CreateUser}
                                                    onChange={(e) => handleInputChange(e, 'CreateUser')} 
                                                    placeholder=" "
                                                />
                                                <label htmlFor="endDate">Created By</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='bottomcol'>
                                        <div class="label-input-box-approval">
                                            <div className="columndescription">
                                                <input
                                                    type="text"
                                                    id="endDate"
                                                    defaultValue={apiData.LongDesc}
                                                    onChange={(e) => showEmptyRow ? setFullDescription(e.target.value) : handleInputChange(e, 'LongDesc')} 
                                                    placeholder=" "
                                                />
                                                <label htmlFor="endDate">Long Description</label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    )}
                </div>
                {/* Panel 2 */}
                <div className="card-body">
                    <div className="card-header">
                        <button type="button" className="toggle-table-icon" onClick={togglePanel2Visibility}>
                            <FontAwesomeIcon icon={panel2Visible ? faArrowDown : faArrowUp} />
                        </button>
                        <h5 className='card-body-title'>
                            Approval Code List
                        </h5>
                        <button className="btn" id='add1' onClick={addNewRow}>
                            <FontAwesomeIcon icon={faAdd} />
                        </button>

                        <Tooltip
                            anchorSelect="#add1"
                            content="Add"
                            place='top'
                        />

                        <button className="btn" id='save1' onClick={saveChildData}>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#save1"
                            content="Save"
                            place='top'
                        />
                    </div>
                    {panel2Visible && (
                        <div class="table-responsive-md">
                            <div className='DetailsForm'>
                                <div class="table-responsive">
                                    <table className="table table-bordered">
                                        {/* Table content */}
                                        <thead className='table-primary'>
                                            <tr className='bg-primary text-white'>
                                                <th>Code ID</th>
                                                <th>Active</th>
                                                <th>Description</th>
                                                <th>Create Date</th>
                                                <th>Created By</th>
                                                <th>Final Approval</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {renderTableRows()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    );
};

export default ApprovalForm;